module.exports = __webpack_public_path__ + "img/header-engagementRingsDainty.6bf4224.jpg";